import { Box, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ToggleRow } from "./ToggleRow";

interface PrivacySectionProps {
  displayRealName: boolean;
  displayDonations: boolean;
  enablePms: boolean;
  onToggle: (field: string, value: boolean) => void;
}

export function PrivacySection({
  displayRealName,
  displayDonations,
  enablePms,
  onToggle,
}: PrivacySectionProps) {
  const [t] = useTranslation();

  return (
    <VStack spacing={5} align="stretch">
      <Text fontSize="xl" fontFamily="heading" fontWeight={600} color="dune.dune">
        {t("screens.settings.privacy")}
      </Text>

      <Box>
        <ToggleRow
          label={t("screens.settings.showRealName")}
          description={t("screens.settings.showRealNameDesc")}
          checked={displayRealName}
          onChange={(v) => onToggle("display_real_name_in_public", v)}
        />
        <ToggleRow
          label={t("screens.settings.showDonations")}
          description={t("screens.settings.showDonationsDesc")}
          checked={displayDonations}
          onChange={(v) => onToggle("display_donations_in_public", v)}
        />
        <ToggleRow
          label={t("screens.settings.allowDMs")}
          description={t("screens.settings.allowDMsDesc")}
          checked={enablePms}
          onChange={(v) => onToggle("enable_pms", v)}
          isLast
        />
      </Box>
    </VStack>
  );
}
